import React from "react";
import { TRUST } from "../../data";

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="bg-[#F4F1E9] border-b border-[#D9D6CC]">
      <ul className="wrap grid grid-cols-2 lg:grid-cols-4">
        {TRUST.map((t, i) => (
          <li key={t} data-testid={`trust-${i}`}
            className={`py-7 md:py-9 px-2 md:px-6 text-center text-[0.95rem] md:text-base text-[#252B2E] border-[#D9D6CC] ${i % 2 ? "border-l" : ""} ${i > 1 ? "border-t lg:border-t-0" : ""} ${i === 2 ? "lg:border-l" : ""}`}>
            {t}
          </li>
        ))}
      </ul>
    </section>
  );
}
